import { useAtomValue } from 'jotai';
import { $CurrentUserAsAvailable } from '@user/shared/current-user';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useUserTitle = (): string => {
  const { t } = useTranslation();
  const user = useAtomValue($CurrentUserAsAvailable);

  return useMemo(() => {
    const titleDes = t('contribute');
    return `${t('user_helmet_title').replace('%1$s', user.nickName).replace('%2$s', titleDes)} | Lemon8`;
  }, [user]);
};

export const useUserLinkPreviewTitle = (): string => {
  const { t } = useTranslation();
  const user = useAtomValue($CurrentUserAsAvailable);

  return t('share_profile_header').replace('{name}', user.nickName);
};

export const useUserDescription = (): string => {
  const { t } = useTranslation();
  return t('share_profile_body');
};
